import { ReactNode } from 'react';
import { routePath } from '~/utils/constants';
import {
  StyledContentContainer,
  StyledMainContainer,
} from '~/layouts/AdminLayout/AdminLayout.style';
import { useAdminAuthGuard } from '~/utils/hook/useAdminAuthGuard';
import { LatestNewsHeader } from '~/layouts/LatestNewsHeader/LatestNewsHeader';
import { AdminReloginDialog } from '~/components/Global/Dialog/AdminReloginDialog';

type TProps = {
  children: ReactNode;
};

export const LatestNewsLayout = ({ children }: TProps) => {
  useAdminAuthGuard({ redirectTarget: routePath.latestNews });

  return (
    <StyledMainContainer>
      <LatestNewsHeader />
      <StyledContentContainer>{children}</StyledContentContainer>
      <AdminReloginDialog />
    </StyledMainContainer>
  );
};
